import type { PaletteId } from "@shared/events";

/**
 * Tile colors (F-301, U-007). C1 owns the canonical palette; until it lands, sell.css defines
 * `--wc-pal-<id>` as `var(--pal-<id>, <local fallback>)`, so when C1 publishes `--pal-*` on :root
 * these tiles pick it up with no code change (D-C2-2).
 */
export function paletteBg(id: PaletteId): string {
  return `var(--wc-pal-${id})`;
}

export function paletteInk(id: PaletteId): string {
  return `var(--wc-pal-${id}-ink)`;
}
